// 섹션으로 부드럽게 스크롤 (상단바 높이만큼 여유)
export function scrollToSection(id, smooth = true) {
  const el = document.getElementById(id);
  if (!el) return;
  const top = el.getBoundingClientRect().top + window.scrollY - 72;
  window.scrollTo({ top, behavior: smooth ? 'smooth' : 'auto' });
}

export const sections = [
  { id: 'about', label: '회사소개' },
  { id: 'business', label: '사업분야' },
  { id: 'products', label: '제품·장비' },
  { id: 'partners', label: '파트너·연혁' },
  { id: 'contact', label: '오시는 길' },
];
